<template>
<div :style="stile">
    <slot></slot>
    <span v-if="admin">
        <v-icon @click="dialog=true" color="red">mdi-pencil</v-icon>
        <v-icon v-if="value" @click="rimuovi" color="red">mdi-delete</v-icon>
        
        <!--
        <v-icon v-if="intemplate && gestiscitemplate" @click="setintemplate" color="grey">mdi-tag-minus</v-icon>
        <v-icon v-if="!intemplate && gestiscitemplate" @click="setintemplate" color="green">mdi-tag-plus</v-icon>
        -->
<!--
                   <input
                    v-if="dialog"
                    class="input"
                    type="text"
                    label="..."
                    :id="id"
                    :value="value"
                    v-on:input="updateValue($event.target.value)">
                    -->
    <v-dialog
      v-model="dialog"
      max-width="900"
      persistent
    >
    <v-card>
      <v-card-title>Modifica Testo</v-card-title>
      <v-card-text>
        <!-- TESTO SEMPLICE -->
        <v-textarea
          v-if="!htmlenabled"
                    class="input"
                    type="text"
                    label="..."
                    :id="id"
                    v-bind:value="value"
                    @input="$emit('input', $event)"/>    
        <ckeditor v-if="htmlenabled" :editor="editor"  v-bind:value="value" @input="$emit('input', $event)" :config="editorConfig" ></ckeditor>  
        </v-card-text>


      <v-card-actions>
      
 
        <v-spacer></v-spacer>
        <!--<v-btn color="red">Annulla</v-btn>-->
        <v-btn @click="dialog=false">OK</v-btn>
      </v-card-actions> 
      
    </v-card>
    </v-dialog>


    </span>
</div>
</template>

<script>
import Vue from 'vue'

import CKEditor from '@ckeditor/ckeditor5-vue';
Vue.use( CKEditor );


import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

  export default {
    components:{
      ckeditor: CKEditor.component
    },
    props: {
      id: {
        type: String
      },
      value: {
        type: String
      },
      admin:{
        type: Boolean
      },
      intemplate:{
        type: undefined
      },
      gestiscitemplate:{
        type: undefined
      },
      htmlenabled:{
        type: String
      }
    },
 data: () => ({
                   
      editor: ClassicEditor,
      editorPlugins: [],
      editorConfig: {
                alignment: {
            options: [ 'left','center', 'right' ]
        },
            toolbar: {
              viewportTopOffset: 30,
              shouldNotGroupWhenFull: true
            }
      },
    dialog:false,
  }),
    methods: {
      updateValue: function (value) {
        this.$emit('input', value)
      },
      setintemplate(){
        if(this.intemplate)
          this.$emit('settemplate', undefined) 
        else
          this.$emit('settemplate', this.value) 
      },
      rimuovi(){
        this.$emit('input', null)
      },
      aggiungi(){
        this.$emit('input', 'scrivi qui')
      }
    },
    computed:{
      stile(){
        var s={}
        if(this.admin){
          if(this.intemplate){
            s ={'background-color':'rgba(0, 255, 0, 0.3)'}
          }
          else{
            s ={'background-color':null}
          }

        }
        return s
      }
    }
  }
</script>